import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { checkAppointment, getBookingList, getBreaks, getTimesAvailable } from '@api/appointmentApi'
import moment from 'moment-timezone';
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import useMediaQuery from '@mui/material/useMediaQuery';
import { getTimeSlots } from '@utils/TimeInterval';
import { TimeZone } from '@utils/constants';
import { CircularProgress } from '@mui/material';
import { useApi, useSetFeedback } from 'use-hook-api';
function DateTimeModal({ open, onConfirm, onClose, setData, value, setValue, time, setTime }) {
  const [selectedTimeIndex, setSelectedTimeIndex] = useState(0)
  const [alreadyBooked, setAlreadyBooked] = useState({})
  const matches = useMediaQuery('(min-width:625px)');
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: matches ? 1000 : 350,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflow: 'auto',
    height: matches ? 600 : 600,
    display: 'block'
  };
  const currentDate = moment().tz(TimeZone).format('YYYY-MM-DD')
  const currentTime = moment().tz(TimeZone).format('HH:mm')


  const [selectedDisables, setSelectedDisables] = useState([])
  const [duration, setDuration] = useState(0)


  const setFeedback = useSetFeedback()

  const [callBookingList, { loading: bookingListLoader }] = useApi({ errMsg: true, successMsg: false })
  const [callDays, { loading: timesLoader }] = useApi({ errMsg: true, successMsg: false })
  const [callBreaks, { loading: BreaksLoader }] = useApi({ errMsg: true, successMsg: false })
  const [CheckTime, { loading: CheckLoader }] = useApi({ errMsg: false, successMsg: false })
  const [dateState, setDateState] = useState({
    allDisableTimes: {},
    daysDisableDates: {},
    times: {},
  })


  // useEffect(() => {
  //     if (value) {
  //         setValue(new Date(value))
  //         setTime(time)
  //     }
  // }, [value, time])

  const isBefore = (tm, date) => {
    const first = moment(tm, 'HH:mm');
    return first.isBefore(moment(currentTime, 'HH:mm')) && moment(date || value).isSame(currentDate)
  }

  const matched = (var1, var2, date) => {

    return var1?.every(item1 => {
      const time1 = moment(item1, 'HH:mm');
      const hasMatch = var2?.some(item2 => {
        const start = moment(time1, 'HH:mm');
        const time2 = moment(item2, 'HH:mm');
        const dur = moment.duration(duration, 'minutes');
        const endTime = start.clone().add(dur);
        return time2.isSame(start) || time2.isBetween(start, endTime)
      });
      return hasMatch || isBefore(item1, date)
    });
  }


  const isDisabled = ({ date }) => {
    const { disableDates, daysDisableDates, times } = dateState
    const day = moment(date).format('ddd').toLowerCase()
    const formatedDate = moment(date).format('YYYY-MM-DD')
    const allDisableTimes = [...new Set([...disableDates?.[formatedDate] || [], ...daysDisableDates[day] || []])]
    const isTimeDisabled = matched(times[day]?.times, allDisableTimes, date)
    return moment(formatedDate).isBefore(currentDate) || isTimeDisabled || !times[day]?.available
  };

  useEffect(() => {
    const { disableDates, daysDisableDates } = dateState
    const formatedDate = moment(value).format('YYYY-MM-DD')
    const day = moment(value).format('ddd').toLowerCase()
    const currentDisableTimes = [...new Set([...disableDates?.[formatedDate] || [], ...daysDisableDates[day] || []])]
    setSelectedDisables(currentDisableTimes)
    console.log('dateState', dateState)
  }, [value, dateState])

  const onDateChange = (e) => {
    setTime('')
    setValue(e)

  }
  const onTimeChange = (time, index) => {
    setSelectedTimeIndex(index)
    const data = {
      "date": moment(value).format('YYYY-MM-DD') + 'T' + time
    }
    CheckTime(checkAppointment(data), () => { }, (result) => {
      console.log('result', result)
      if (result.status === 404) {
        setTime(time)
        const data = {
          "date": moment(value).format('YYYY-MM-DD') + 'T' + time
        }
        setData(data.date)
        onConfirm(value, time)
      }
      else {

        setFeedback([`There is already an appointment scheduled for this time. Please choose a different time.`, 'error'])
      }
    })
  }

  useEffect(() => {

    const promise1 = new Promise((resolve, reject) => {
      callBookingList(getBookingList(), ({ data }) => {
        resolve(data)
      }, reject)

    })

    const promise2 = new Promise((resolve, reject) => {
      callDays(getTimesAvailable(), ({ data }) => {
        resolve(data)
      }, reject)
    })

    const promise3 = new Promise((resolve, reject) => {
      callBreaks(getBreaks({ page: null }), ({ data }) => {
        resolve(data)
      }, reject)
    });

    (async () => {
      try {
        const disableDates = {}, daysDisableDates = {}, times = {}
        const allPromises = await Promise.allSettled([promise1, promise2, promise3])
        const data1 = Object.assign(allPromises[0].value?.results, [])
        const data2 = Object.assign(allPromises[1].value?.results, [])
        const data3 = Object.assign(allPromises[2].value?.results, [])
        const duration = data2[0]?.duration
        setDuration(duration)
        data1?.forEach((item) => {
          const date = moment(item.date).tz(TimeZone).format('YYYY-MM-DD')
          const time = moment(item.date).tz(TimeZone).format('HH:mm')
          if (disableDates[date]) {
            disableDates[date].push(time)
          } else {
            disableDates[date] = [time]
          }
        })

        setAlreadyBooked(disableDates)

        data3?.forEach((item) => {
          const date = item.date
          const start = item.start
          const end = item.end
          if (disableDates[date]) {
            disableDates[date].push(...getTimeSlots(start, end, duration))
          } else {
            disableDates[date] = [...getTimeSlots(start, end, duration)]
          }
        })
        data2?.[0] && Object.entries(data2[0]?.working_hours).forEach(([key, item]) => {
          const day = key
          const start = item.start
          const end = item.end
          if (times[day]) {
            times[day].push({
              available: item.available,
              times: [...getTimeSlots(start, end, duration)]
            })
          } else {
            times[day] = {
              available: item.available,
              times: [...getTimeSlots(start, end, duration)]
            }
          }

          item?.breaks?.forEach((breakItem) => {
            const breakStart = breakItem.start
            const breakEnd = breakItem.end
            if (daysDisableDates[day]) {
              daysDisableDates[day].push(...getTimeSlots(breakStart, breakEnd, duration))
            }
            else {
              daysDisableDates[day] = [...getTimeSlots(breakStart, breakEnd, duration)]
            }
          })
        })
        setDateState({ disableDates, daysDisableDates, times })
      }
      catch (err) {
        console.log('err', err)
      }
    })()

  }, [])
  const checkTimeDisability = (tm) => {
    console.log('selectedDisables', selectedDisables)
    return selectedDisables?.some(select => {
      const start = moment(tm, 'HH:mm');
      const time2 = moment(select, 'HH:mm');
      const dur = moment.duration(duration, 'minutes');
      const endTime = start.clone().add(dur);
      return time2.isSame(start) || time2.isBetween(start, endTime)

    }) || isBefore(tm)
  }

  return (
    <div>

      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {
            (timesLoader || BreaksLoader || bookingListLoader) ? <CircularProgress /> :
              <div className='flex md:h-full h-[90vh] md:flex-row flex-col overflow-auto'>
                <div className="bg-[#212529] text-center text-white pt-10 md:w-[55%]">
                  <div className="text-3xl">Select your appointment</div>
                  <div className="w-[350px] md:w-full m-auto">
                    <Calendar next2Label={false} prev2Label={false} minDate={new Date()} value={value} onChange={onDateChange}
                      tileDisabled={isDisabled}
                    />
                  </div>
                </div>
                <div className='bg-white p-7 md:w-[45%]'>

                  <div className="flex flex-col gap-2">
                    {
                      value === undefined ? <div className='text-center'>Please select date First</div> :
                        <div className="flex flex-col gap-2">
                          <div className='text-lg mb-3 mt-7'>What time works best?</div>
                          <div className=' grid grid-cols-2 gap-5'>
                            {/* {timesAvailable?.map((tm, i) => {
​
                                                    return (
                                                        breakTimes.includes(tm) ?
                                                            null
                                                            :
​
                                                            <Button variant={tm === time ? "contained" : "outlined"}
                                                                disabled={disabledDates.includes(ConvertToUTC(`${moment(value).format('YYYY-MM-DD')}T${tm}`)) || breakTimes.includes(tm) || moment(value).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD') && moment(tm, 'HH:mm').isBefore(moment(currentTime, 'HH:mm'))}
                                                                className={`text-md py-2 ${tm === time ? 'bg-primary' : ''}`} onClick={() => { onTimeChange(tm, i) }}>
                                                                {
                                                                    (disabledDates.includes(ConvertToUTC(`${moment(value).format('YYYY-MM-DD')}T${tm}`)) || breakTimes.includes(tm) || moment(value).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD') && moment(tm, 'HH:mm').isBefore(moment(currentTime, 'HH:mm'))) ? 'BOOKED' :
​
​
​
                                                                        (SelectedTimeIndex === i && CheckLoader) ?
                                                                            <CircularProgress size={23} /> : tm
                                                                }
                                                            </Button>
                                                    )
                                                })} */}
                            {dateState?.times?.[moment(value).format('ddd')?.toLowerCase()]?.times?.map((tm, i) => {
                              console.log('tm', tm, time, value)

                              return (

                                <Button key={tm} variant={tm === time ? 'contained' : "outlined"}
                                  disableElevation
                                  fullWidth
                                  disabled={checkTimeDisability(tm)}
                                  className={`text-md py-2 ${tm === time ? 'bg-secondary text-white' : 'text-black'}`}
                                  onClick={() => { onTimeChange(tm, i) }}>

                                  {
                                    alreadyBooked?.[moment(value).format('YYYY-MM-DD')]?.includes(tm) ? 'BOOKED' : checkTimeDisability(tm) ? 'BREAK' : (CheckLoader && selectedTimeIndex === i) ? <CircularProgress size={23} /> : tm
                                  }
                                </Button>
                              )
                            })}
                          </div>
                          {/* <div className='col-span-2 md:col-span-1 mt-5 text-end'>
                                                <Button disableElevation variant="contained" className='bg-primary' onClick={() => onNext()}>Confirm</Button>
                                            </div> */}
                        </div>

                    }
                  </div>


                </div>

              </div>
          }
        </Box>
      </Modal>
    </div>
  )
}

export default DateTimeModal